import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ForbiddenComponent } from './components';
import { EmailVerificationComponent } from './components/email-verification/email-verification.component';
import { LoginComponent } from './components/login/login.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { PasswordResetConfirmComponent } from './components/password-reset-confirm/password-reset-confirm.component';
import { PasswordResetComponent } from './components/password-reset/password-reset.component';
import { RegistrationComponent } from './components/registration/registration.component';
import { ResendEmailComponent } from './components/resend-email/resend-email.component';

const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'email-verification/:code', component: EmailVerificationComponent },
    { path: 'login', component: LoginComponent },
    { path: 'resend-email', component: ResendEmailComponent },
    { path: 'reset-password', component: PasswordResetComponent },
    { path: 'reset-password/:id/:token', component: PasswordResetConfirmComponent },
    { path: 'code-login', component: LoginComponent },
    { path: 'register', component: RegistrationComponent },
    { path: '403', redirectTo: '/forbidden' },
    { path: '404', redirectTo: '/not-found' },
    { path: 'forbidden', component: ForbiddenComponent },
    { path: 'not-found', component: NotFoundComponent },
    { path: '**', redirectTo: '/not-found' },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PublicRoutingModule {}
